export default "__VITE_ASSET__BdvAOJoK__"